import React from 'react';
import { Advisor } from '../types';

interface AdvisorCardProps {
  advisor: Advisor;
  onClick: () => void;
}

const AdvisorCard: React.FC<AdvisorCardProps> = ({ advisor, onClick }) => {
  const renderStars = (rating: number) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <span key={i} className="text-yellow-400">★</span>
      );
    }

    if (hasHalfStar) {
      stars.push(
        <span key="half" className="text-yellow-400">☆</span>
      );
    }

    const remainingStars = 5 - stars.length;
    for (let i = 0; i < remainingStars; i++) {
      stars.push(
        <span key={`empty-${i}`} className="text-gray-300">★</span>
      );
    }

    return stars;
  };

  // for tracking view details 
   const handleViewDetailsClick = () => {
    console.log('View Details Clicked:', advisor.name);
    if (window.gtag) {
      window.gtag('event', 'view_details_click', {
        event_category: 'User Interaction',
        event_label: advisor.name,
      });
    }
    onClick();
  };

  return (
    <div
      onClick={handleViewDetailsClick}
      className="card hover:shadow-lg cursor-pointer transition-shadow duration-200 transform hover:-translate-y-1"
    >  
      <div className="flex items-center space-x-4 mb-4">
      {/* Image section is disabled for version 1. Will be added in future */}

         {/* <img
          src={advisor.image}
          alt={advisor.name}
          className="w-16 h-16 rounded-full object-cover"
        />  */}
        <div>
          <div className="flex items-center space-x-2">
        <h3 className="text-lg font-semibold text-gray-900">{advisor.name}</h3>
        {advisor.featured && (
              <span className="bg-yellow-200 text-yellow-800 text-[11px] font-semibold px-2 py-0.5 rounded-full">
                ⭐ Featured
              </span>
      )}
    </div>
          <p className="text-sm text-gray-600">{advisor.title}</p>
        {/* website link  */}
        {advisor.website && (
            <a
              href={advisor.website}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mt-1 text-sm font-medium text-blue-600 bg-blue-50 px-2 py-0.5 rounded hover:underline"
            >
              🌐 {advisor.website.replace(/^https?:\/\//, '')}
            </a>
  )}
        </div>
      </div>

      <div className="mb-4">
         {/* Rating section is disabled for version 1. Will be added in future */}

        {/* <div className="flex items-center space-x-2 mb-0">
          <div className="flex items-center">
            {renderStars(advisor.rating)}
          </div> 
          <span className="text-sm text-gray-600">
            {advisor.rating} ({advisor.reviewCount} reviews)
          </span>
        </div> */}
        
        <p className="text-sm text-gray-600 mb-2">
          <span className="font-medium">{advisor.experience} years experience</span>
        </p>
        
        <p className="text-sm text-gray-600 mb-2">
          📍 {advisor.location}
        </p>
        
        {/* Pricing section is disabled for version 1. Will be added in future */}

        {/* <p className="text-lg font-semibold text-primary-600">
         ${advisor.hourlyRate}/hour 
        </p> */}
      </div>

      <div className="mb-4">
        <h4 className="text-sm font-medium text-gray-900 mb-2">How Can I Help:</h4>
        <div className="flex flex-wrap gap-1">
          {advisor.specializations.slice(0, 3).map((spec, index) => (
            <span
              key={index}
              className="px-2 py-1 bg-primary-100 text-primary-700 text-xs rounded-full"
            >
              {spec}
            </span>
          ))}
          {advisor.specializations.length > 3 && (
            <span className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-full">
              +{advisor.specializations.length - 3} more
            </span>
          )}
        </div>
      </div>

      <div className="mb-4">
        <p className="text-sm text-gray-600 line-clamp-3">
          {advisor.bio}
        </p>
      </div>

      <div className="flex justify-between items-center">
        <div className="flex space-x-1">
          {advisor.certifications.slice(0, 3).map((cert, index) => (
            <span
              key={index}
              className="px-2 py-1 bg-green-100 text-green-700 text-xs rounded"
            >
              {cert}
            </span>
          ))}
        </div>
        
        <button className="btn-primary text-sm">
          View Details
        </button>
      </div>
    </div>
  );
};

export default AdvisorCard; 